import { SortOption } from './SortOption';

export type AssetTypeFilter = 'images' | 'videos' | 'gifs' | 'documents';
export type UploadedByFilter = 'me' | 'anyone';

export interface AssetFilters {
  search?: string;
  type?: AssetTypeFilter;
  uploadedBy?: UploadedByFilter;
  sort: SortOption;
}

export const DEFAULT_FILTERS: AssetFilters = {
  search: undefined,
  type: undefined,
  uploadedBy: undefined,
  sort: { by: 'created_at', direction: 'desc' },
};
